export const addKeyframes = (timeline, target, property, steps, duration, position = 0) => {
  steps.forEach(([percent, value], index) => {
    const start = index === 0 ? percent : steps[index - 1][0]
    timeline.to(target, { [property]: value, duration: ((percent - start) / 100) * duration, ease: 'none' }, position + (start / 100) * duration)
  })
}

export const IGNITE_SECONDS = 1.6
export const IGNITE_STAGGER = 0.17
export const NEON_IGNITE = [
  [0, 0],
  [6, 0.9],
  [8, 0],
  [15, 0],
  [16, 1],
  [19, 0.15],
  [24, 0.15],
  [26, 1],
  [30, 0.45],
  [34, 1],
  [55, 1],
  [57, 0.7],
  [59, 1],
  [100, 1],
]

export const DIGIT_IDLE = [
  [0, 1],
  [92, 1],
  [93, 0.8],
  [94, 1],
  [95, 0.88],
  [96, 1],
  [100, 1],
]
export const DIGIT_OFF_SECONDS = 0.28
export const DIGIT_OFF = [
  [0, 1],
  [20, 0.2],
  [38, 0.9],
  [60, 0.1],
  [75, 0.5],
  [100, 0],
]
export const DIGIT_ON_SECONDS = 1.1
export const DIGIT_ON_FLARE_END = 42
export const DIGIT_ON = [
  [0, 0],
  [10, 1],
  [16, 0.15],
  [26, 1],
  [32, 0.5],
  [42, 1],
  [100, 1],
]
